// Generated, DO NOT EDIT MANUALLY.
import { createTypedClient } from '../../../pplx/frontend/api-clients/core/client.js';
export const spacesClient = createTypedClient();
export const createSpacesClient = (config) => createTypedClient(config);
